if (jQuery('body').hasClass('single-location')) {
  var map; //TODO solo if single-location
  function gminit() {
    var mapOptions = {
      zoom: 8,
      center: new google.maps.LatLng(-34.397, 150.644)
    };
    map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);
  }
}

function resize_cover() {
  jQuery(".wef-measure > .cover").each(function () {
    jQuery(this).css("height", 0.368 * jQuery(this).width());
  });
}

function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

jQuery(window).resize(function () {
  resize_cover();
});

var ajaxurl = 'https://www.tolucacultural.com/wp-admin/admin-ajax.php';
//var ajaxurl = 'https://www.tolucacultural.com/tc-ajax.php';
jQuery(document).ready(function ($) {

  $.ajaxSetup({cache: true});
  var url = ajaxurl + '?action=footer_count';
  $.get(url, function (response) {
    $("#footer_count").html(response);
  }, 'html');

  if (inIframe()) {
    $('.tc-logo').hide();
  }
  resize_cover();
  var v_width = jQuery(".wef-measure").outerWidth();
  var foot_width = jQuery("#foot-width").outerWidth();
  jQuery(".fb-post").attr("data-width", v_width + "px");
  jQuery("#fb-footer").attr("data-width", foot_width + "px");


  if ($('body').hasClass('logged-in')) {
    $("#update_one").on("click", function () {
      $("#update_one").html('<i class="fa fa-refresh fa-spin"><i/>');
      var post_idj = $("#update_one").attr('post_id');
      var data = {action: 'update_one', post_id: post_idj};
      $.post(ajaxurl, data, function (res) {
        if (res.res == 'success') {
          console.log(res.data);
          $("#update_one").html('DONE!');
          //window.location.reload();
        } else {
          $("#update_one").html('ERROR');
        }
      }, 'json');
    });
  }
  //if($('body').hasClass('single-event')){
  //	//$(document).delegate('*[data-toggle="lightbox"]', 'click', function(event) { event.preventDefault(); $(this).ekkoLightbox(); });
  //}
  var containerk = document.querySelector('#front-posters');
  if (containerk != null) {
    $('.front-btns').on('click', function (event) {
      event.preventDefault();
      var items = new Array(
        'Espera espera mi compa...',
        'Aguado hermano ahi viene..',
        'Relax amigo ya casi...',
        'Tranquilo solo espera unos segundos...',
        'Relax la banda...'
      );
      var item = items[Math.floor(Math.random() * items.length)];
      $('#front-posters').html('<p class="text-center"><br>' + item + '<br><i class="fa fa-spinner fa-spin fa-5x"></i><br><br><br></p>');
      var catsj = $(this).attr('cats');
      var data = {action: 'front_posters', cats: catsj};
      $.post(ajaxurl, data, function (res) {
        $('#front-posters').html(res);
        new Masonry(document.querySelector('.posters'), {itemSelector: ".poster-container"});
        $('.carousel-caption')[0].scrollIntoView(true);
      }, 'html');
    });
  }
  $('[data-toggle="popover"]').popover({trigger: 'hover', 'placement': 'top'});

  $('[data-toggle="offcanvas"]').click(function () {
    $('.row-offcanvas').toggleClass('active')
  });
  var close_thanks = function () {
    $('#close-thanks').on('close.bs.alert', function () {
      var data = {action: 'close_thanks'};
      $.post(ajaxurl, data, function (res) {
        console.log(res);
      }, 'json');
    });
  };
  close_thanks();

  $('.carousel[data-type="multi"] .item').each(function() {
    var next = $(this).next();
    if (!next.length) {
      next = $(this).siblings(':first');
    }
    next.children(':first-child').clone().appendTo($(this));

    for (var i = 0; i < 2; i++) {
      next = next.next();
      if (!next.length) {
        next = $(this).siblings(':first');
      }

      next.children(':first-child').clone().appendTo($(this));
    }
  });

  /**
   $.ajax({
				type: "POST",
				dataType : 'json',
				url : ajaxurl,
				data : {
					action : 'login_connect',
					fb_user : response,
				},
				success : function(res) {
					if (res.error === undefined) {
						if (res.refresh === '1') {
							window.location.reload();
						}
					} else {
						console.log(res.error);
					}
				},
				error : function(res) {
					console.log(res);
				}
			});
   */
  //enviar datos y opacar el modal
  //si funciona refrescar
  //si no funciona volver a colocar el contenido


  /**
   jQuery(document).ready(function () {
	var width = jQuery("#wpbody").width();
	var height = jQuery("#wpbody").height();
	jQuery("#progress-bk").css("width",width);
	jQuery("#progress-bk").css("height",height);
	jQuery("#progress-bk-inner").css("height",height);

	jQuery( "#bkform" ).submit(function( event ) {
	    jQuery("#progress-bk").css("display","block");
		jQuery("#progress-bk").animate({ opacity:"0.7" });
	return;
	});

	jQuery( "#bkupfrom" ).submit(function( event ) {
	    jQuery("#progress-bk").css("display","block");
		jQuery("#progress-bk").animate({ opacity:"0.7" });
	return;
	});

});














   $('form#entrar').submit(function(event) {
			event.preventDefault();
			$('#spin-login').html('<i class="icon-spinner icon-spin"></i>');
			var str = $(this).serializeArray();
			console.log(str);

			$.ajax({
				dataType : 'json',
				data : {
					action : 'tc_login',
					login_data : str
				},
				success : function(res) {
					if(res.errors !== undefined){
						$('#spin-login').html('');
						if(res.errors.login_username !== undefined){
							$('#login-username-error').html(res.errors.login_username);
						} else {
							$('#login-username-error').html('');
						}
						if(res.errors.login_pwd !== undefined){
							$('#login-pwd-error').html(res.errors.login_pwd);
							$('input#login-pwd').attr('value','');
						} else {
							$('#login-pwd-error').html('');
						}
					} else {
						if(res.success !== undefined){
							window.location.reload();
						} else {
							console.log(res);
						}
					}
				},
				error : function(){
					$('form#login').html('<div class"alert alert-error">El sistema esta saturado intentalo en un par de minutos</div>');
				}
			});

			return false;
		});
   //Registro y Login de FB
   $('#tc-fb-connect').bind('click',function(){
			FB.login(function(response){
				console.log(response);
				if(response.status === 'connected'){
					FaceSinc.login();
				} else {
					//alert('El login falló, intenta en un par de minutos porfavor')
				}
			}, {scope: 'user_events,manage_pages,user_about_me,rsvp_event,email,create_event'});
		});


   //Registro y login modal
   //TODO on click show login y show registro sacan la forma por ajax dataType html $("#log").html( res );
   $('form#registro').submit(function(event) {
		event.preventDefault();
		$('#spin-register').html('<i class="icon-spinner icon-spin"></i>');
		var str = $(this).serializeArray();
		$.ajax({
			dataType : 'json',
			data : {
				action : 'tc_register',
				form_data : str
			},
			success : function(res) {
				$('#spin-register').html('');
				if(res.errors !== undefined){
					if(res.errors.register_username !== undefined){
						$('#register-username-error').html(res.errors.register_username);
					} else {
						$('#register-username-error').html('');
					}
					if(res.errors.register_email !== undefined){
						$('#register-email-error').html(res.errors.register_email);
					} else {
						$('#register-email-error').html('');
					}
					if(res.errors.register_pwd !== undefined){
						$('#register-pwd-error').html(res.errors.register_pwd);
						$('input#register-pwd').attr('value','');
						$('input#register-pwd2').attr('value','');
					} else {
						$('#register-pwd-error').html('');
					}
					if(res.errors.register_captcha !== undefined){
						$('#register-captcha-error').html(res.errors.register_captcha);
					} else {
						$('#register-captcha-error').html('');
					}
				} else {
					if(res.success !== undefined){
						window.location.reload();
					} else {
						console.log(res);
					}
				}
			},
			error : function(){
				$('form#registro').html('<div class"alert alert-error">El sistema esta saturado intentalo en un par de minutos</div>');
			}
		});

		return false;
	});



   FaceSinc = {};
   FaceSinc.login = function(){
		$.ajax({
			dataType : 'json',
			data : {
				action : 'login_connect'
			},
			success : function(res) {
				if (res.error === undefined) {
					if (res.refresh === '1') {//vuelve a checar el usuario por esas ondas del cache
						window.location.reload();
					}
				} else {
					console.log(res.error);
				}
			},
			error : function(res) {
				console.log('Algo paso! refresca la pantalla y vuelvelo a intentar');
			}
		});
	};
   FaceSinc.logout = function(){
		$.ajax({
			dataType : 'json',
			data : {
				action : 'logout_ajax'
			},
			success : function(res) {
				window.location.reload();
			}
		});

	};

   $("#to-login, #to-register").click(function(){
			$("#show-register, #show-login").toggle('slow');

	});
   //login popup
   var split = location.search.replace('?', '').split('&').map(function(val){
	  return val.split('=');
	});
   //console.log(split);
   if( split[0][0] == 'action' && (split[0][1] == 'login' || split[0][1] == 'register') ) {
		$("#registro").modal('show');
		if(split[0][1] == 'register'){
			$("#show-login").toggle('slow');
			$("#show-register").toggle('slow');
		}
	}
   */
});